export default "__VITE_ASSET__40b55c1f__"